module.exports = __webpack_public_path__ + "img/Prog-final-Inperson-day1rms-v1.006a028f.svg";